// Table.js

import React, { useState} from "react";
import { useTable, useFilters, useSortBy, usePagination, useGlobalFilter} from "react-table";
import BTable from "react-bootstrap/Table";
import {CSVLink} from "react-csv";
import { Button} from 'react-bootstrap';
import "../../css/bootstrap.min.css";
import "../../css/react-table.css";
import { useHistory } from 'react-router-dom';
import "./Table.css";
import tableCss from './Table.css';

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter
}) 
{
  return (
      <div className={tableCss.filterDiv} style={{width:'100%'}}>
      <div className={tableCss.filterSpan}>Search </div>
      <input
        value={globalFilter || ""}
        onChange={e => {
          setGlobalFilter(e.target.value || undefined);
        }}
        placeholder={" Find Book "}
        style={{
          fontSize: "1.4rem",
          width: "200px"
        }}
      />
    </div>
  );
}

function CustomFieldFilter({ filter, setFilter }) {
  return (
    <input
      value={filter || ""}
      onChange={e => {
        setFilter("customFields", e.target.value || undefined);
      }}
      placeholder={`Search Custom Field`}
    />
  );
}

function parseData(myInput) {
  // 1. Convert object of objects into array of objects
  // create new keys
  // Filter out for date range > 2016 for now
  let newArray = []
  for (var key in myInput) {
      if (myInput.hasOwnProperty(key)) {
          const newRow = Object.assign({"newDate": new Date(key)}, {"Date":key}, {"Year":key.split("-")[0]}, myInput[key])
          if (parseInt(newRow["Year"])>2016) {
            newArray.push(newRow)
          }
      }
  }
  return newArray
}

export default function Table({ columns, data, hiddenColumns, downloadHeaders }) {

    const history = useHistory();

    const [filterInput, setFilterInput] = useState('');

 
    
    const handleFilterChange = e => {
        const value = e.target.value || undefined;
        setFilter("Code", value);
        setFilterInput(value);
    };
  

    // Use the useTable Hook to send the columns and data to build the table
    const {
        getTableProps, // table props from react-table
        getTableBodyProps, // table body props from react-table
        headerGroups, // headerGroups, if your table has groupings
        rows, // rows for the table based on the data passed
        prepareRow, // Prepare the row (this function needs to be called for each row before getting the row props)
        setFilter,
        setGlobalFilter,
        preGlobalFilteredRows,
        state,


        page, // Instead of using 'rows', we'll use page,
        // which has only the rows for the active page
    
        // The rest of these things are super handy, too ;)
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        allColumns,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },
    


    }= useTable(
    {
      columns,
      data,
      initialState: { 
          pageIndex: 0,
          sortBy: [
            {
                id: 'title',
                desc: true,
            }
        ],
        hiddenColumns: hiddenColumns
      }
    },
    useFilters, // Adding the useFilters Hook to the table
    useGlobalFilter,
    useSortBy,
    usePagination,
    // You can add as many Hooks as you want. Check the documentation for details. You can even add custom Hooks for react-table here
  );

  /* 
    Render the UI for your table
    - react-table doesn't have UI, it's headless. We just need to put the react-table props from the Hooks, and it will do its magic automatically
  */

 const routeChange=()=> {
  let path = `/FirebaseFileUpload`;
  history.push(path);
  }

  return (    
    <div style={{width:"100%"}}>
                    
      <div className="form-group row" style={{width:"100%"}}>
      <div style={{textAlign:"left", width:"100%"}}>
      <GlobalFilter
        preGlobalFilteredRows={preGlobalFilteredRows}
        globalFilter={state.globalFilter}
        setGlobalFilter={setGlobalFilter}
      />
      </div>
      <div className="col-md-2" style={{textAlign:"left"}}>
      {/*<Button variant="secondary" className="px-4" style={{fontSize:"15px"}} onClick={routeChange}>Upload PDF</Button>*/}
      </div>
      </div>
      
     <div><b>Books Found: {rows.length}</b></div>

    {/* <CustomFieldFilter filter={state.filter} setFilter={setFilter} />
    <input value={filterInput} onChange={handleFilterChange} placeholder={"Subject Code"}/> */}
 {/*     
    <pre>
        <code>
          {JSON.stringify(
            {
              pageIndex,
              pageSize,
              pageCount,
              canNextPage,
              canPreviousPage,
            },
            null,
            1
          )}
        </code>
      </pre>
*/} 

    <BTable striped bordered hover {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()} style={{backgroundColor:"#86abd2"}}>
            {headerGroup.headers.map(column => (
              <th
              {...column.getHeaderProps(column.getSortByToggleProps())}
              className={
                column.isSorted
                  ? column.isSortedDesc
                    ? "sort-desc"
                    : "sort-asc"
                  : ""
              }
            >
              {column.render("Header")}
              {/* Add a sort direction indicator */}
              <span style={{'width':'5px', 'height': '5px'}}>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' 🔽'
                        : ' 🔼'
                      : ''}
              </span>
            </th>
            
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {page.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <td style={{color:'black',width:'100%'}} {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </BTable>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <div className="pagination" style={{"width":"100%","verticalAlign":"top", "text-align" : "center"}}>
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage} style={{"marginBottom":"2px","marginTop":"2px", "backgroundColor":"#86abd2" , "fontWeight":"bold", "height":"40px", "width":"100px"}}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage} style={{"marginBottom":"2px", "marginTop":"2px", "height":"40px", "backgroundColor":"#86abd2" , "fontWeight":"bold", "width":"100px"}}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage} style={{"marginBottom":"2px","marginTop":"2px", "height":"40px", "backgroundColor":"#86abd2" , "fontWeight":"bold", "width":"100px"}}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} style={{"marginBottom":"2px","marginTop":"2px", "height":"40px", "backgroundColor":"#86abd2" , "fontWeight":"bold", "width":"100px"}}>
          {'>>'}
        </button>{' '}
        </div>
        <div className="pagination" style={{"width":"100%","verticalAlign":"top", "text-align" : "center", "paddingBottom":"10px"}}>
        <span style={{"display": "inline-flex", "alignItems": "center"}}>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        </div>
        <div className="pagination" style={{"width":"100%","verticalAlign":"top", "text-align" : "center", "paddingBottom":"10px"}}>
        <span style={{"width":"300px", "display": "inline-flex", "alignItems": "center"}}>
          <b>Go to page:</b>{'    '} <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{"width":"30px", "display":"inline"}}
          />
        </span>
        </div>
        <div className="pagination" style={{"width":"100%","verticalAlign":"top", "text-align" : "center", "paddingBottom":"10px"}}>
        <span style={{"width":"100px","display": "inline-flex", "alignItems": "center"}}>
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
          style={{"width":"100px", "backgroundColor":"#86abd2" , "fontWeight":"bold", "height":"40px"}}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
        </span>
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/containers/Table/Table.js